import UnicodeDetector from "@/modules/unicodeDetector/views/UnicodeDetector.vue";

export const UnicodeDetectorRoutes = [
    {
        path: '/unicode-detector',
        component: UnicodeDetector,
    }
];